// Korte melding rechtsonder. De container staat in body.html (#toastContainer).
//
// De tekst wordt als tekst ingevoegd, nooit als HTML. Een melding van de
// server of een naam van een club kan dus geen opmaak of script meenemen.

export function toast(msg,type='') {
  const c=document.getElementById('toastContainer');
  const t=document.createElement('div');
  t.className=`toast ${type}`;
  const icons={success:'ti-check',error:'ti-alert-circle',warning:'ti-alert-triangle'};
  if (icons[type]) { const i=document.createElement('i'); i.className=`ti ${icons[type]}`; t.appendChild(i); }
  t.appendChild(document.createTextNode(String(msg ?? '')));
  c.appendChild(t);
  setTimeout(()=>t.remove(),3000);
}
